import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import OverheadTankCleaning from "@/pages/OverheadTankCleaning";
import UndergroundTankCleaning from "@/pages/UndergroundTankCleaning";
import CommercialTankCleaning from "@/pages/CommercialTankCleaning";
import ResidentialTankCleaning from "@/pages/ResidentialTankCleaning";
import DLFPhase from "@/pages/areas/DLFPhase";
import GolfCourseRoad from "@/pages/areas/GolfCourseRoad";
import SohnaRoad from "@/pages/areas/SohnaRoad";
import Sector5657 from "@/pages/areas/Sector5657";
import SushantLok from "@/pages/areas/SushantLok";
import PalamVihar from "@/pages/areas/PalamVihar";
import MGRoad from "@/pages/areas/MGRoad";
import NirvanaCountry from "@/pages/areas/NirvanaCountry";
import Sector4950 from "@/pages/areas/Sector4950";
import UdyogVihar from "@/pages/areas/UdyogVihar";
import Blog1 from "@/pages/Blog1";
import Blog2 from "@/pages/Blog2";
import Blog3 from "@/pages/Blog3";
import Blog4 from "@/pages/Blog4";
import Blog5 from "@/pages/Blog5";
import BlogIndex from "@/pages/BlogIndex";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/overhead-water-tank-cleaning-gurugram" element={<OverheadTankCleaning />} />
          <Route path="/underground-water-tank-cleaning-gurugram" element={<UndergroundTankCleaning />} />
          <Route path="/commercial-water-tank-cleaning-gurugram" element={<CommercialTankCleaning />} />
          <Route path="/residential-tank-cleaning-gurugram" element={<ResidentialTankCleaning />} />
          <Route path="/water-tank-cleaning-dlf-phase-gurugram" element={<DLFPhase />} />
          <Route path="/water-tank-cleaning-golf-course-road-gurugram" element={<GolfCourseRoad />} />
          <Route path="/water-tank-cleaning-sohna-road-gurugram" element={<SohnaRoad />} />
          <Route path="/water-tank-cleaning-sector-56-57-gurugram" element={<Sector5657 />} />
          <Route path="/water-tank-cleaning-sushant-lok-gurugram" element={<SushantLok />} />
          <Route path="/water-tank-cleaning-palam-vihar-gurugram" element={<PalamVihar />} />
          <Route path="/water-tank-cleaning-mg-road-gurugram" element={<MGRoad />} />
          <Route path="/water-tank-cleaning-nirvana-country-gurugram" element={<NirvanaCountry />} />
          <Route path="/water-tank-cleaning-sector-49-50-gurugram" element={<Sector4950 />} />
          <Route path="/water-tank-cleaning-udyog-vihar-gurugram" element={<UdyogVihar />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/how-often-clean-water-tank-gurugram" element={<Blog1 />} />
          <Route path="/blog/signs-water-tank-needs-cleaning" element={<Blog2 />} />
          <Route path="/blog/overhead-vs-underground-tank-cleaning" element={<Blog3 />} />
          <Route path="/blog/waterborne-diseases-dirty-tanks-gurugram" element={<Blog4 />} />
          <Route path="/blog/diy-vs-professional-tank-cleaning-gurugram" element={<Blog5 />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}
export default App;
